import PreferencesMenuItem from './PreferencesMenuItem';

export default PreferencesMenuItem;
export * from './types';
export { PreferencesMenuItem };
